import { defineStore } from 'pinia'
import { ref } from 'vue'

const STORAGE_KEY_PANEL = 'kbFloatPanel'

export const useKnowledgeFloatStore = defineStore('knowledgeFloat', () => {
  const isExpanded = ref(false)
  const panelPosition = ref({ x: 0, y: 0 })
  const panelSize = ref({ width: 720, height: 520 })

  // 悬浮窗内的页签
  const openTabs = ref([])
  const activeTabId = ref(null)

  // 目录面板是否展开
  const sidebarVisible = ref(true)

  // ---- 面板位置/大小持久化 ----

  function loadPanelLayout() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY_PANEL)
      if (saved) {
        const data = JSON.parse(saved)
        if (data.position) panelPosition.value = data.position
        if (data.size) panelSize.value = data.size
      }
    } catch {
      // ignore
    }
  }

  function savePanelLayout() {
    localStorage.setItem(STORAGE_KEY_PANEL, JSON.stringify({
      position: panelPosition.value,
      size: panelSize.value
    }))
  }

  function setPanelPosition(pos) {
    panelPosition.value = pos
    savePanelLayout()
  }

  function setPanelSize(size) {
    panelSize.value = size
    savePanelLayout()
  }

  // ---- 面板开关 ----

  function togglePanel() {
    isExpanded.value = !isExpanded.value
  }

  function openPanel() {
    isExpanded.value = true
  }

  function closePanel() {
    isExpanded.value = false
  }

  // ---- 页签管理 ----

  function openDocument({ documentId, nodeId, title }) {
    const existing = openTabs.value.find(t => t.documentId === documentId)
    if (existing) {
      activeTabId.value = existing.tabId
      return existing
    }

    const tab = {
      tabId: `ftab_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
      documentId,
      nodeId,
      title: title || '未命名文档'
    }
    openTabs.value.push(tab)
    activeTabId.value = tab.tabId
    return tab
  }

  function closeTab(tabId) {
    const idx = openTabs.value.findIndex(t => t.tabId === tabId)
    if (idx === -1) return

    openTabs.value.splice(idx, 1)

    if (activeTabId.value === tabId) {
      if (openTabs.value.length > 0) {
        const newIdx = Math.min(idx, openTabs.value.length - 1)
        activeTabId.value = openTabs.value[newIdx].tabId
      } else {
        activeTabId.value = null
      }
    }
  }

  function switchTab(tabId) {
    activeTabId.value = tabId
  }

  function toggleSidebar() {
    sidebarVisible.value = !sidebarVisible.value
  }

  return {
    isExpanded,
    panelPosition,
    panelSize,
    openTabs,
    activeTabId,
    sidebarVisible,
    loadPanelLayout,
    savePanelLayout,
    setPanelPosition,
    setPanelSize,
    togglePanel,
    openPanel,
    closePanel,
    openDocument,
    closeTab,
    switchTab,
    toggleSidebar
  }
})
